

















































import { Component, Vue } from 'vue-property-decorator'
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import LocationWorkerCreate from '@/components/Locations/LocationWorkerCreate.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm';
import LocationWorkerDto from '@/models/LocationWorkers/LocationWorkerDto';
import LocationWorkerType from '@/components/Locations/Display/LocationWorkerType.vue';
import DeleteLocationWorkerRequest from '@/models/LocationWorkers/DeleteLocationWorkerRequest';
import LocationWorkerEdit from '@/components/Locations/LocationWorkerEdit.vue';

@Component({
    name: 'LocationWorkersList',
    components: { LocationWorkerCreate, LocationWorkerType, LocationWorkerEdit
    }
})
export default class extends GiganautVue {

    async navigateToWorker(item: LocationWorkerDto) {
        this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: item.workerId } });
    }

    get locationWorkers(): LocationWorkerDto[] {
        return LocationDetailsModule.locationWorkers;
    }

    get loading() {
        return LocationDetailsModule.loadingLocationWorkers;
    }

    async created() {
        await this.getWorkers();
    }

    private async getWorkers() {
        await LocationDetailsModule.getLocationWorkers();
    }

    async deleteLocationWorker(locationWorker: LocationWorkerDto) {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this association?', options);
        if (result) {
            const request = new DeleteLocationWorkerRequest();
            request.locationId = locationWorker.locationId;
            request.locationWorkerId = locationWorker.id;
            await LocationDetailsModule.deleteLocationWorker(request);
        }
    }

    private search = '';
    
    private headers = [
        { text: 'First Name', value: 'worker.person.firstName' },
        { text: 'Last Name', value: 'worker.person.lastName' },
        { text: 'Email Address', value: 'worker.emailAddress' },
        { text: 'Phone Number', value: 'worker.mobilePhoneNumber' },   
        { text: 'Link Type', value: 'type' },
        { text: 'Actions' },
    ]
}
